var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customized && _vm.customized.store_config)?_c('group',[_c('cell',{attrs:{"title":"当前所在门店","is-link":""}},[_c('p',{on:{"click":_vm.handlerLogout}},[_vm._v(_vm._s(_vm.customized.store_config.store_name))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }